import {
  CCCLinkListState,
  LinkListItem,
} from "../../components/link-list/index";
import { CCCLinkList } from "../../components/link-list/index";

// Components to use
import "../../components/link-list/index";

/**
 * Link lister class for common link list panels
 *
 */
export default class LinkLister {
  public customElement: CCCLinkList = null;

  /**
   * Sets title for the component
   * @param title string
   */
  setTitle(title: string): void {
    if (this.customElement) this.customElement.setKeyState("title", title);
  }

  /**
   * Sets links param
   * @param links LinkListItem[]
   */
  setLinks(links: LinkListItem[]): void {
    if (this.customElement) this.customElement.setKeyState("links", links);
  }

  /**
   * Sets more link in case we need it
   * @param link string
   */
  setMoreLink(link: string): void {
    if (this.customElement) this.customElement.setKeyState("moreLink", link);
  }

  /**
   * Handles the loading component in case it exists.
   * @param loading boolean
   */
  setLoading(loading: boolean): void {
    if (this.customElement) this.customElement.setLoading(loading);
  }

  /**
   * Sets empty list msg state key
   * @param msg
   */
  setEmptyListMsg(msg: string): void {
    if (this.customElement) this.customElement.setKeyState("emptyListMsg", msg);
  }

  setCreateButton(link: LinkListItem): void {
    if (this.customElement)
      this.customElement.setKeyState("createButton", link);
  }

  /**
   * Sets all data as possible for the list component
   * @param data
   */
  setData(data: CCCLinkListState): void {
    // need to be set before the links
    if (data.emptyListMsg) {
      this.setEmptyListMsg(data.emptyListMsg);
    }
    this.setTitle(data.title);
    this.setLinks(data.links);
    if (data.moreLink) {
      this.setMoreLink(data.moreLink);
    }
    if (data.createButton) {
      this.setCreateButton(data.createButton);
    }

    this.setLoading(false);
  }

  hide(): void {
    if (this.customElement) this.customElement.hide();
    this.setLoading(false);
  }
}
